import api from './api';

class AuthService {
    async login(email, password) {
        const response = await api.post('users/auth/login/', { email, password });
        if (response.data.access) {
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            return response.data;
        }
        return response.data;
    }

    async register(data) {
        return api.post('users/', data);
    }

    async getCurrentUser() {
        return api.get('users/me/');
    }

    logout() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
    }
}

export default new AuthService();
